import * as THREE from "three";
import { traverseOwnObjects } from "../../utils/geometry.js";

export class SelectionOutline {
  constructor(scene) {
    this.scene = scene;
    this.group = null;
    this.material = new THREE.MeshBasicMaterial({
      color: 0x0080ff,
      side: THREE.BackSide,
      depthWrite: true
    });
  }

  /** @param {Set<FurnitureElement>} [withComponents] pieces outlined with their components */
  update(selected, withComponents) {
    // Remove previous outline group
    // Outline meshes borrow the furniture's geometry and the shared outline material, so nothing here is disposed.
    if (this.group) {
      this.scene.remove(this.group);
      this.group = null;
    }

    if (selected.length === 0) return;

    this.group = new THREE.Group();
    this.group.name = 'SelectionOutline';
    this.group.renderOrder = 0;
    this.group.userData.isOutline = true;

    // Skips invisible / mid-fade subtrees entirely.
    const addOutline = (obj) => {
      if (!obj.visible || obj.userData?._fadeActive) return false;
      if (obj.isMesh && obj.geometry) {
        const outlineMesh = new THREE.Mesh(obj.geometry, this.material);
        obj.updateWorldMatrix(true, false);
        outlineMesh.applyMatrix4(obj.matrixWorld);
        outlineMesh.scale.multiplyScalar(1.03);
        // Editor-only shell; PathTracingManager reads this to keep it out of the BVH.
        outlineMesh.userData.isOutline = true;
        this.group.add(outlineMesh);
      }
    };
    for (const furnitureElement of selected) {
      traverseOwnObjects(furnitureElement, addOutline,
        { includeComponents: withComponents?.has(furnitureElement) });
    }

    this.scene.add(this.group);
  }
}
